import { Auth } from "aws-amplify";
import { useEffect, useRef } from "react";
import {
  UserType,
  useRecordCpaDashboardAccessMutation,
} from "../../../graphql/types";
import { getSingleCognitoUserTypeFromGroups } from "../utilities/adminConsoleUserType";

const useRecordCpaDashboardAccess = (userType: UserType | ""): void => {
  const accessWasRecordedForThisMount = useRef(false);
  const [recordDashboardAccess] = useRecordCpaDashboardAccessMutation();

  useEffect(() => {
    if (
      userType !== UserType.ChamberAdmin ||
      accessWasRecordedForThisMount.current
    ) {
      return;
    }

    let effectWasCancelled = false;

    const recordAccessForPrimaryChamberAdmin = async (): Promise<void> => {
      try {
        const session = await Auth.currentSession();
        const rawUserType = getSingleCognitoUserTypeFromGroups(
          session.getAccessToken().decodePayload()["cognito:groups"]
        );

        // Chamber staff reuse the ChamberAdmin UI role. Only the primary raw
        // CHAMBER_ADMIN Cognito identity should update this access timestamp.
        if (
          effectWasCancelled ||
          rawUserType !== UserType.ChamberAdmin ||
          accessWasRecordedForThisMount.current
        ) {
          return;
        }

        accessWasRecordedForThisMount.current = true;
        await recordDashboardAccess();
      } catch (_error) {
        // Access telemetry must never prevent an authenticated admin from using
        // the dashboard. A later document mount can safely retry.
      }
    };

    recordAccessForPrimaryChamberAdmin();

    return () => {
      effectWasCancelled = true;
    };
  }, [recordDashboardAccess, userType]);
};

export default useRecordCpaDashboardAccess;
